import { faXmark } from '@fortawesome/pro-solid-svg-icons';
import { IconButton, IconButtonProps } from '@mui/material';
import { ForwardRefIcon } from '../icons/ForwardRefIcon';

type CloseButtonProps = {
  onClick: IconButtonProps['onClick'];
};

export const CloseButton = (props: CloseButtonProps) => (
  <IconButton
    disableRipple
    onClick={props.onClick}
    id="close_dialog"
    sx={{
      position: 'absolute',
      right: 8,
      top: 8,
      color: theme => theme.palette.grey[500],
    }}
  >
    <ForwardRefIcon icon={faXmark} />
  </IconButton>
);
